import menusService from '../../services/menus'

const state = {
  menus: []
}

// getters
const getters = {
  menuById: state => (id) => {
    return state.menus.find(m => m.menuId === id);
  }
}

// actions
const actions = {
  async getMenusAction(context) {
    await menusService.getMenusByRestaurant()
                      .then(data => {
                          context.commit('setMenusState', data);
                      });
  },
  async createMenuAction(context, menu) {
    await menusService.createMenu(menu);
    context.commit('addMenuState', menu);
  },
  async updateMenuAction(context, menu) {
    await menusService.updateMenu(menu.menuId, menu);
    context.commit('updateMenuState', menu);
  },
  async deleteMenuAction(context, menuId) {
    await menusService.deleteMenu(menuId);
    context.commit('deleteMenuState', menuId)
  }
}
// mutations
const mutations = {
  addMenuState(state, menu) {
    state.menus.push(menu);
  },
  setMenusState(state, menus) {
    state.menus = menus;
  },
  updateMenuState(state, menu) {
    let index = state.menus.findIndex(m => m.menuId === menu.menuId);
    if (index > -1) {
      state.menus[index] = menu;
    }
  },
  deleteMenuState(state, menuId) {
    let index = state.menus.findIndex(m => m.menuId === menuId);
    if (index > -1) {
      state.menus.splice(index, 1);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}